import React from "react";
import Base from "../../../components/Base";
import { Redirect } from "react-router-dom";
import { Button, Icon, Upload, Table, Progress } from "antd";
import { UploadStatus, useFileUpload } from "./use-file-upload";
import { isSuperUser } from "../../../utils/is-superuser";
import { TableColumns } from "./columns";
import moment from "moment";

import "./styles.css";
import { FetchStatus, useFetchFiles } from "./use-fetch-files";

export function AtualizarParcelasLotePage(props) {
  const userId = Number(localStorage.getItem("auth_userid"));
  const { upload, filename, progress, status: uploadStatus } = useFileUpload(
    userId
  );
  const { status, data, refresh } = useFetchFiles();

  if (!isSuperUser()) {
    return <Redirect to="/dashboard" />;
  }

  const tableData = React.useMemo(
    () =>
      (data || []).map(file => ({
        key: file.id,
        id: file.id,
        created_at: file.created_at
          ? moment(file.created_at).format("DD/MM/YYYY HH:mm:ss")
          : "---",
        dt_processamento: file.dt_processamento
          ? moment(file.dt_processamento).format("DD/MM/YYYY HH:mm:ss")
          : "---",
        total: file.processo_total_items,
        progress: [
          file.processo_total_items,
          file.processo_total_processed,
          file.processo_total_error
        ],
        status: [file.status, file.erro],
        saida: [file.processo_total_success, file.processo_total_error]
      })),
    [data]
  );

  const isUploading =
    uploadStatus === UploadStatus.UPLOADING ||
    uploadStatus === UploadStatus.ERROR ||
    uploadStatus === UploadStatus.SUCCESS;
  const isFailed = uploadStatus === UploadStatus.ERROR;
  const isSuccess = uploadStatus === UploadStatus.SUCCESS;

  return (
    <Base
      title="Atualização de Parcelas"
      subTitle="Atualizar parcelas de acordos em lote"
      extra={[
        <a href={"/modelo_planilha_atualizacao_parcelas.xlsx"}>
          <Button icon="download" type="ghost">
            Baixar modelo
          </Button>
        </a>,
        <Upload
          name="file"
          accept=".xlsx"
          customRequest={upload}
          showUploadList={false}
        >
          <Button
            type="primary"
            disabled={isUploading && progress !== 100 && !isFailed}
          >
            <Icon type="upload" />
            Fazer upload (.xlsx)
          </Button>
        </Upload>
      ]}
    >
      <div className="upload__container">
        <div className="upload__title">
          <Icon type="file-text" />
          <span>Lista de importações</span>
        </div>

        {isUploading && (
          <div className="upload__progress">
            <span>
              {!isFailed && !isSuccess && <Icon type="loading" />}
              &nbsp;
              <span style={{ opacity: 0.6 }}>{filename}</span>
            </span>
            <Progress
              percent={progress}
              status={isFailed ? "exception" : isSuccess ? "success" : "active"}
            />
          </div>
        )}

        <Table
          pagination={false}
          dataSource={tableData}
          columns={TableColumns}
          loading={status === FetchStatus.LOADING}
          scroll={{ x: true }}
          locale={{
            emptyText: "Vazio"
          }}
        />
      </div>
    </Base>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Acordos/AtualizarParcelasLote/index.jsx